module.exports = __webpack_public_path__ + "media/assets/images/flags/sv-2c40408446a76352476e3f51a5e7aa19.svg";